import React from 'react';
import { useTranslation } from 'react-i18next';

import './empty-list.scss';

const EmptyList = () => {
    const [ t ] = useTranslation();

    return (
        <div
            className="fullslip__empty-list"
            data-test-id="betslip;empty-betslip-message"
        >
            {t('betslip.empty_betslip')}
            <span className="fullslip__fake-stake-box"></span>
        </div>
    );
};

export default EmptyList;
